import { useEffect, useRef, useState } from "react"

const useYouTubeVideo = ({ clickTracking }) => {
  const [playerOpen, setPlayerOpen] = useState(false)
  const [transcriptionOpen, setTranscriptionOpen] = useState(false)
  const callerRef = useRef(null)

  const { videoTracking, transcriptionTracking } = clickTracking

  const handleVideoClick = (open) => {
    if (open) {
      videoTracking && videoTracking()
    }

    setPlayerOpen(open)
  }

  const handleTranscriptionClick = (open) => {
    if (open) {
      transcriptionTracking && transcriptionTracking()
    }
    setTranscriptionOpen(!transcriptionOpen)
  }

  const returnFocus = () => {
    if (callerRef.current) {
      callerRef.current.focus()
    }
  }

  const setCaller = () => {
    const { activeElement } = document
    if (activeElement) callerRef.current = activeElement
  }

  useEffect(() => {
    if (!playerOpen) {
      setTimeout(() => {
        returnFocus()
      }, 300)
      return
    }
    setCaller()
    setTimeout(() => {
      const element = document.querySelector(
        ".ds-button.ds-modal-container__close-button.ds-button--high-contrast"
      )
      if (element) element.focus()
    }, 500)
  }, [playerOpen])

  useEffect(() => {
    if (!transcriptionOpen) {
      setTimeout(() => {
        returnFocus()
      }, 300)
      return
    }
    setCaller()
    setTimeout(() => {
      const element = document.querySelector(
        ".ds-button.ds-modal-container__close-button.ds-button--high-contrast"
      )
      if (element) element.focus()
    }, 500)
  }, [transcriptionOpen])

  return {
    playerOpen,
    transcriptionOpen,
    handleVideoClick,
    handleTranscriptionClick
  }
}

export default useYouTubeVideo
